const SUBSCRIPTION_TYPES = {
    MONTHLY: 'Month',
    ANNUAL: 'Annual',
    INSTALMENTS: 'Instalments',
    ONE_OFF: 'OneOff',
    WEEK: 'Week'
};

export {SUBSCRIPTION_TYPES};
